<template>
    <th v-bind="$attrs" class="v-data-table__color-bg grey lighten-4 text-center">
        <slot />
    </th>
</template>

<script>
export default {
    props: {},
    components: {},
    data() {
        return {};
    },
    mounted() {},
    methods: {},
};
</script>

<style lang="scss" scoped></style>
